import React from "react";
import "../GalleryComponent/GalleryComponentCss/ ReligiousEventShowcase.css";

import img1 from "../Images/event1.jpg";
import img2 from "../Images/event2.jpg";
import img3 from "../Images/event4.jpg";
import img4 from "../Images/event3.jpg";

export default function EventGallery() {
  return (
    <section className="event-container">
      <h2 className="event-title">
      गावातील धार्मिक कार्यक्रम
त्रिपुरारी पौर्णिमा व दुर्गा माता दौड
      </h2>

      <div className="event-layout">

        {/* LEFT BIG IMAGE */}
        <img src={img1} className="event-big-left" alt="event" />

        {/* CENTER TWO SMALL */}
        <div className="event-center">
          <img src={img2} className="event-small" alt="small1" />
          <img src={img3} className="event-small" alt="small2" />
        </div>

        {/* RIGHT BIG IMAGE */}
        <img src={img4} className="event-big-right" alt="event4" />

      </div>
    </section>
  );
}
